import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { ChakraProvider } from "@chakra-ui/react";
import { Toaster } from "react-hot-toast";
import { UserProvider } from "contexts/userContext/UserContext";
import { QueryParamProvider } from "use-query-params";
import { ReactRouter6Adapter } from "use-query-params/adapters/react-router-6";
import { CourierProvider } from "contexts/courierContext/CourierContext";
import { FeesProvider } from "contexts/feesContext/FeesContext";

import App from "./App";
import "./index.css";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <BrowserRouter>
    <QueryParamProvider adapter={ReactRouter6Adapter}>
      <ChakraProvider>
        <UserProvider>
          <CourierProvider>
            <FeesProvider>
              <App />
              <Toaster
                toastOptions={{
                  className: "toast-style",
                }}
              />
            </FeesProvider>
          </CourierProvider>
        </UserProvider>
      </ChakraProvider>
    </QueryParamProvider>
  </BrowserRouter>
);
